import { createSlice } from '@reduxjs/toolkit';

import { initSucceeded } from '../../actions/cabinListActions';

const searchInformationSlice = createSlice({
  name: 'searchInformation',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initSucceeded, (_state, action) => ({ ...action.payload.searchInformation }));
  },
});

export default searchInformationSlice.reducer;
